import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { Link } from "react-router-dom";
import { compose } from 'redux';
import DisplayTestDetails from "./display_test_details";

const StudentSummary = ({data, questionSets}) => {
    //console.log(questionSets);
    //console.log(data);
    const testData =[]
    Object.keys(data.value).forEach( x => {
        testData.push({testData:data.value[x], testnumber:x})
    })
    //console.log(testData)
    return (
        <div>
            <div className="mycard text-center" >
                {/* <div className="card-body text-dark">
                    <h3 className="card-title">{data.Name}</h3>
                    <p className="card-text text-secondary">Giving Exam: {data.isGivingExam ? 'Yes' : 'No'}
                    </p>
                    <p className="card-text text-secondary">Disqualified: {data.isDisqualified ? 'Yes' : 'No'}
                    </p>
                </div> */}
                <div className="mycard-body text-dark">
                    <h3 className="card-title text-color">{data.key}</h3>
                    <Container style={{display:'flex', flexWrap:'wrap', justifyContent:'center', alignSelf:'center', }}>
                        <Container style={{padding:5, boxShadow:'none', display:'flex', flexWrap:'wrap', justifyContent:'center', alignSelf:'center',}}>
                            {testData && testData.map(testdata => {
                                return(<DisplayTestDetails testData={testdata} questionSets={questionSets} key={testdata.testnumber+data.key}/>)
                            })}
                        </Container>
                    </Container>
                </div>
            </div>
        </div>
    )
}

const NewStudentSummary = ({data}) => {
    return (
        <>
        <div>
            <Row>
                <Col xs={12} md={6}>

                </Col>
            </Row>
        </div>
        </>
    )
}


export default StudentSummary
